import Types from '../Types'
import Immutable from 'seamless-immutable'
import { createReducer } from 'reduxsauce'

export const INITIAL_STATE = Immutable({
  error: null,
  findAllAttempting: false,
  rewards: [],
  pageCount: 0,
  findOneAttempting: false,
  reward: {},
  addAttempting: false,
  saveAttempting: false
})

const ACTION_HANDLERS = {
  [Types.FIND_ALL_REWARDS_ATTEMPT]: (state, action) =>
    state.merge({ findAllAttempting: true }),
  [Types.FIND_ALL_REWARDS_SUCCESS]: (state, action) =>
    state.merge({
      findAllAttempting: false,
      rewards: action.result.rewards,
      pageCount: action.result.pageCount,
      error: null
    }),
  [Types.FIND_ALL_REWARDS_FAILURE]: (state, action) =>
    state.merge({ findAllAttempting: false, error: action.error }),

  [Types.ADD_REWARD_ATTEMPT]: (state, action) =>
    state.merge({ findOneAttempting: true }),
  [Types.FIND_ONE_REWARD_SUCCESS]: (state, action) =>
    state.merge({
      findOneAttempting: false,
      reward: action.result,
      error: null
    }),
  [Types.FIND_ONE_REWARD_FAILURE]: (state, action) =>
    state.merge({ findOneAttempting: false, error: action.error }),

  [Types.ADD_REWARD_ATTEMPT]: (state, action) =>
    state.merge({ addAttempting: true }),
  [Types.ADD_REWARD_SUCCESS]: (state, action) =>
    state.merge({
      addAttempting: false,
      reward: action.result,
      error: null
    }),
  [Types.ADD_REWARD_FAILURE]: (state, action) =>
    state.merge({ addAttempting: false, error: action.error }),

  [Types.SAVE_REWARD_ATTEMPT]: (state, action) =>
    state.merge({ saveAttempting: true }),
  [Types.SAVE_REWARD_SUCCESS]: (state, action) =>
    state.merge({
      saveAttempting: false,
      reward: action.result,
      error: null
    }),
  [Types.SAVE_REWARD_FAILURE]: (state, action) =>
    state.merge({ saveAttempting: false, error: action.error })
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)



// WEBPACK FOOTER //
// ./src/redux/reward/rewardReducer.js